<div class="progress-bar" fxLayout="column-reverse">
  <div class="progress-value" [ngStyle]="{'height': value/max * 100 + '%'}">
  </div>
</div>
